<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-4 m-lg-3">
          <div class="card-body">
            <div class="row p-0 align-items-center rental-payment">
              <div class="col mt-4 ms-sm-4">
                <h4>Payment Configuration</h4>
              </div>
              <div
                class="col-lg-2 col-md-3 col-sm-4 col-12 d-flex justify-content-end  me-4"
              >
                <llp-button
                  :load-spinner="showaddUserSpinner"
                  classNames="btn-secondary text-nowrap new-btn d-none d-sm-block"
                  type="button"
                  @click:button="PaymenyPriority"
                >
                  Payment Priority
                </llp-button>
                <llp-button
                  :load-spinner="showaddUserSpinner"
                  classNames="btn-secondary text-nowrap new-btn d-block d-sm-none"
                  type="button"
                  @click:button="PaymenyPriority"
                >
                  Priority
                </llp-button>
              </div>
            </div>

            <div class="row">
               <div v-if="loading" class="loader-container">
            <div class="spinner"></div>
               </div>
              <div
                v-for="gateway in paymentGateways"
                :key="gateway.pg_id"
                class="m-4"
              >
                <div>
                  <h5>{{ gateway.payment_gateway_name }}</h5>
                </div>

                <div class="d-flex flex-wrap gap-3">
                  <div
                    v-for="method in gateway.methods"
                    :key="`${gateway.pg_id}-${method.payment_method_id}`"
                    class="p-2 d-flex align-items-center"
                  >
                    <input
                      type="checkbox"
                      class="form-check-input me-2"
                      :id="`${gateway.pg_id}-${method.payment_method_id}`"
                      :value="`${gateway.pg_id}-${method.payment_method_id}`"
                      v-model="selectedMethods"
                    />
                    <label
                      :for="`${gateway.pg_id}-${method.payment_method_id}`"
                      class="mb-0"
                    >
                      {{ method.name }}
                    </label>
                  </div>
                </div>
              </div>
               <div class="col-lg-1 col-md-3 col-sm-6 ms-lg-4">
              <llp-button
                :load-spinner="showaddUserSpinner"
                classNames="btn-secondary text-nowrap new-btn mt-2 group-charges-btn"
                type="button"
                @click:button="SaveConfigurationPayments"
              >
                Save
              </llp-button>
               </div>
            </div>

           
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from "@/services/network.service";

export default {
  data() {
    return {
      menuOptions: [],
      paymentGateways: [],
      selectedMethods: [],
      showaddUserSpinner: false,
      originalSelections: {},
      loading: true,
    };
  },
  mounted() {
    this.fetchingPaymentConfiguration();
  },
  methods: {
    PaymenyPriority() {
      this.$router.push("/payment-priorities");
    },

    async fetchingPaymentConfiguration() {
      try {
        const response = await NetworkService.get("payment-method-list");
        this.paymentGateways = response.data;
          this.loading = false;
        this.selectedMethods = [];
        this.originalSelections = {};

        this.paymentGateways.forEach((gateway) => {
          gateway.methods.forEach((method) => {
            const uniqueId = `${gateway.pg_id}-${method.payment_method_id}`;
            const isSelected = method.selected === 1 || method.selected === "1";

            this.originalSelections[uniqueId] = isSelected;
            if (isSelected) {
              this.selectedMethods.push(uniqueId);
            }
          });
        });
      } catch (error) {
         this.loading = false;
        this.$refs.toast.show(
          "Unable to fetch payment configurations",
          "error"
        );
      }
    },

    async SaveConfigurationPayments() {
      const selectedConfigurations = [];
      this.paymentGateways.forEach((gateway) => {
        gateway.methods.forEach((method) => {
          const uniqueId = `${gateway.pg_id}-${method.payment_method_id}`;
          const isCurrentlySelected = this.selectedMethods.includes(uniqueId);
          const wasOriginallySelected = this.originalSelections[uniqueId];

          if (isCurrentlySelected !== wasOriginallySelected) {
            selectedConfigurations.push({
              method: method.payment_method_id,
              selected: isCurrentlySelected ? 1 : 0,
              pg_id: gateway.pg_id,
            });
          }
        });
      });
      if (selectedConfigurations.length === 0) {
        this.$refs.toast.show("No changes to save", "info");
        return;
      }
      try {
        const response = await NetworkService.post(
          "store-payment-methods",
          selectedConfigurations
        );
        this.$refs.toast.show(response.data.message || "Saved successfully");
        setTimeout(() => {
           this.loading = true;
          this.fetchingPaymentConfiguration();
        }, 2500);
      } catch (error) {
        this.$refs.toast.show(
          "Unable to save the payment configurations",
          "error"
        );
      }
    },
  },
};
</script>
